import { React, useEffect, useState, useRef, useCallback, initChoice, initChoice2, updateChoices, alertSwal, fetchPost, Breadcrumb, TuiGrid01, getGridDatas, refreshGrid, reSizeGrid, InputComp1, InputComp2, SelectComp3 } from "../comp/Import";

import { useNavigate } from "react-router-dom";

import { UserIcon ,KeyIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

import logoImage from "../../images/logo/logo.png";

const Login = () => {
   const [username, setUsername] = useState("");
   const [password, setPassword] = useState("");
   const [error, setError] = useState("");
   const navigate = useNavigate();

   const handleLogin = async () => {
      const data = {
         id: username,
         pw: password,
      };

      let result = await ZZ_USER_LOGIN(data);

      if (result.result === "SUCCESS") {
         sessionStorage.setItem('loginInfo', JSON.stringify(result));
         navigate('/Main', { state: { result: result } });
      } else {
         setError("아이디 또는 비밀번호가 일치하지 않습니다.");
      }
   };

   // 엔터키 이벤트 핸들러 추가
   const handleKeyPress = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') {
         handleLogin();
      }
   };

   // 홈페이지로 이동하는 함수
   const goToHomepage = () => {
      window.open('https://nongdong.nonghyup.com/', '_blank');
   };

   //---------------------- api -----------------------------

   const ZZ_USER_LOGIN = async (data: any) => {
      try {
         const result = await fetchPost(`ZZ_USER_LOGIN`, data);
         return result as any;
      } catch (error) {
         console.error("ZZ_USER_LOGIN Error:", error);
         throw error;
      }
   };

   return (
      <div className="w-full h-screen bg-gray-100 flex flex-col items-center ">
         <div className="flex h-[85%] w-[60%] justify-center items-center">
            <div className="w-full h-[75%] flex justify-center items-center bg-white rounded-lg">
               <div className="w-1/3 px-10 py-40   ">
                  <div className="space-y-3 w-full">
                     <div className="mb-24 flex flex-col items-center justify-center space-y-1">
                        <div className="flex">
                           <div className="font-[농협체M] text-6xl text-blue-700">NH</div>
                           <div className="font-[농협체M] text-6xl text-green-600">농협</div>
                        </div>
                        <div  className="font-[농협체M] text-4xl text-gray-500">동인회</div>
                        <div className="font-[농협체M] text-xl text-red-500 mt-1 px-4 py-1 border-2 border-red-400 rounded-full">관리자용</div>
                     </div>
                     <div className="flex items-center relative">
                        <div className="absolute left-2 top-1/2 transform -translate-y-1/2 z-10 border-r pr-2 border-gray-400">
                           <UserIcon className="w-[25px]" />
                        </div>

                        <input 
                           type="text" 
                           value={username} 
                           placeholder="User ID"
                           className="w-full pl-16 pr-3 py-3 border border-gray-300 rounded-lg text-base shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" onChange={(e) => setUsername(e.target.value)} />
                     </div>
                     <div className="flex items-center relative">
                        <div className="absolute left-2 top-1/2 transform -translate-y-1/2 z-10 border-r pr-2 border-gray-400">
                           <KeyIcon className="w-[25px]" />
                        </div>
                        <input
                           type="password"
                           placeholder="Password"
                           value={password}
                           className="w-full pl-16 pr-3 py-3 border border-gray-300 rounded-lg text-base shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                           onChange={(e) => setPassword(e.target.value)}
                           onKeyPress={handleKeyPress}
                        />
                     </div>

                     <div>
                        <button className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg shadow-md" onClick={handleLogin}>
                           로그인
                        </button>
                     </div>

                     {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                  </div>
               </div>
               <div className="w-2/3 h-full relative">
                  <div className="w-full h-full  bg-[url('./images/login/main_2.jpg')] bg-no-repeat  bg-cover bg-center rounded-r-lg"></div>
                  
                  <div className="absolute inset-0 flex flex-col items-center justify-center">
                     <div className="bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-xl border-2 border-blue-500 transform hover:scale-105 transition-all duration-300 cursor-pointer" onClick={goToHomepage}>
                        <div className="flex items-center space-x-2 mb-3">
                           <div className="flex items-center space-x-1">
                              <img 
                                 src={`${process.env.PUBLIC_URL}/images/logo/logo.png`} 
                                 alt="NH농협동인회 로고" 
                                 className="h-8 w-auto" 
                              />
                              <div className="flex ">
                                 <div className="font-[농협체M] text-3xl text-green-600">농협</div>
                                 <div className="font-[농협체M] text-3xl text-gray-600 ">동인회</div>

                              </div>
                           </div>
                        </div>
                        <h2 className="text-xl font-bold text-gray-800 mb-2">회원용 홈페이지 바로가기</h2>
                        <p className="text-gray-600 mb-4">농협동인회 홈페이지에서 다양한 서비스를 이용하세요!</p>
                        <div className="flex items-center justify-center space-x-2 text-blue-600 font-semibold">
                           <span>https://nongdong.nonghyup.com</span>
                           <ArrowTopRightOnSquareIcon className="w-5 h-5" />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="w-full h-[15%] justify-self-end">
            <div className="bg-blue-950 h-full">
               <div className="h-full flex p-5">
                  <div className="w-[23%] h-full flex justify-center items-center text-white text-xl shadow ">
                     <div className="flex flex-col items-center justify-center ">
                        <div className="flex">
                           <div className="font-[농협체M] text-3xl text-gray-500">NH</div>
                           <div className="font-[농협체M] text-3xl text-gray-500">농협</div>
                        </div>
                        <div  className="font-[농협체M] text-2xl text-gray-500">동인회</div>
                     </div>
                  </div>
                
                  <div className="w-[54%] h-full  text-white text-sm text-gray-200/60">
                     <div className="h-full">                        
                        <div>
                           <div className="w-full flex pt-6">
                              <div>주소 : 서울특별시 마포구 신촌로 66 농협신촌복합빌딩 11층</div>
                              <div className="lg:ps-2">/ 대표전화 : 02-734-1108, 02-6401-1108</div>
                              <div className="lg:ps-2">/ FAX : 02-734-2041</div>
                           </div>
                        </div>
                        <div className="w-full border-b my-2"></div>
                        <div className="w-full flex px-2">
                           <div>© 2025. 농협동인회. All Rights Reserved.</div>
                        </div>
                     </div>
                  </div>
                  <div className="w-[23%]"></div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Login;
